<div class="rx-card">
	<div class="rx-card-title">
		<div class="rx-title-row rx-app-flex-container-row rx-app-flex-container-row--align-center">
			<div class="treatment-information-title">{{ 'TreatmentInformation.TreatmentInformation' | translate }}</div>
		</div>
	</div>
	<div class="rx-card-body print-context">
		<table mat-table [dataSource]="treatments">
			<ng-container matColumnDef="Tooth No">
				<th mat-header-cell *matHeaderCellDef scope="col">
					{{ 'TreatmentInformation.ToothNo' | translate }}
				</th>
				<td mat-cell *matCellDef="let tooth" [id]="'treatment-info-art-tooth-no-' + tooth.ToothID">
					{{ tooth.ToothID | mapper: getToothNumberById.bind(this) | async }}
				</td>
			</ng-container>

			<ng-container matColumnDef="Treatment">
				<th mat-header-cell *matHeaderCellDef scope="col">
					{{ 'TreatmentInformation.Treatment' | translate }}
				</th>
				<td mat-cell *matCellDef="let tooth" [id]="'treatment-info-art-treatment-' + tooth.ToothID">
					<ng-container *ngFor="let indication of getTreatmentIndications(tooth); let last = last">
						<span>{{ indication | artTreatmentTranslate }}</span
						><span *ngIf="!last">, </span>
					</ng-container>
				</td>
			</ng-container>

			<ng-container matColumnDef="Material">
				<th mat-header-cell *matHeaderCellDef scope="col">
					{{ 'TreatmentInformation.Material' | translate }}
				</th>
				<td mat-cell *matCellDef="let tooth">--</td>
			</ng-container>

			<ng-container matColumnDef="Preparation design">
				<th mat-header-cell *matHeaderCellDef scope="col">
					{{ 'TreatmentInformation.PreparationDesign' | translate }}
					<div>{{ 'Buccal/Lingual' | translate }}</div>
				</th>
				<td mat-cell *matCellDef="let tooth">--</td>
			</ng-container>

			<ng-container matColumnDef="Shade">
				<th mat-header-cell *matHeaderCellDef scope="col">
					{{ 'TreatmentInformation.Shade' | translate }}
					<div>
						{{ 'TreatmentInformation.Incisal' | translate }}/{{ 'TreatmentInformation.Body' | translate }}/{{
							'TreatmentInformation.Gingival' | translate
						}}
					</div>
				</th>
				<td mat-cell *matCellDef="let tooth">--</td>
			</ng-container>

			<tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
			<tr
				mat-row
				*matRowDef="let tooth; columns: displayedColumns"
				[id]="'treatment-info-' + tooth.ToothID"
			></tr>
			<tr id="treatment-info-no-data" class="mat-row detail-row show-nodata" *matNoDataRow>
				<td class="mat-cell" [attr.colspan]="displayedColumns.length">
					{{ 'TreatmentInformation.NoData' | translate }}
				</td>
			</tr>
		</table>
	</div>
</div>
